<template>
  <img :src="qrCodeUrl" :style="{ width: '100%' }" @touchstart="onTouchStart" @touchend="onTouchEnd" crossorigin="" />
</template>

<script setup lang="ts">
  import { ref, Ref } from 'vue';

  const props = defineProps<{
    objId?: string | number;
    qrCodeUrl?: string;
  }>();

  // @ts-expect-error: Unreachable code error
  const timer: Ref<NodeJS.Timeout> = ref(0);
  const onTouchStart = () => {
    clearTimeout(timer.value);
    timer.value = setTimeout(() => {
      _jt_.sendTracker({
        event_type: 'long_press',
        block_desc: 'qr_code',
        button_desc: 'long_press_btn',
        parameters: { objId: `${props.objId ?? ''}` },
      });
    }, 400);
  };

  const onTouchEnd = () => {
    clearTimeout(timer.value);
  };
</script>
